// src/api/user/userApi.js
import api from '../shared/AxiosConfig';

// 🔹 Admin kullanıcı listeleme
const getAllUsers = (params) => api.get('/user/admin/users', { params });
const getUserByGuid = (userGuid) => api.get(`/user/admin/users/${userGuid}`);
const getUserAddresses = (userGuid) => api.get(`/user/admin/users/${userGuid}/addresses`);


// 🔹 Profil işlemleri
const getUser = () => api.get('/user');
const updateUser = (data) => api.put('/user', data);
const changePassword = (data) => api.put('/user/change-password', data);

// 🔹 Adres işlemleri
const getAddresses = () => api.get('/user/addresses');
const addAddress = (data) => api.post('/user/addresses', data);
const updateAddress = (guid, data) => api.put(`/user/addresses/${guid}`, data);
const deleteAddress = (guid) => api.delete(`/user/addresses/${guid}`);
const setDefaultAddress = (guid) => api.put(`/user/address/set-default/${guid}`);

// 🔹 Kart işlemleri
const getPaymentMethods = () => api.get('/user/payment-methods');
const addPaymentMethod = (data) => api.post('/user/payment-methods', data);
const updatePaymentMethod = (guid, data) => api.put(`/user/payment-methods/${guid}`, data);
const deletePaymentMethod = (guid) => api.delete(`/user/payment-methods/${guid}`);
const setDefaultPaymentMethod = (guid) => api.put(`/user/payment/set-default/${guid}`);

// Toplu export
export const userApi = {
    getAllUsers,
    getUserByGuid,
    getUserAddresses,
    getUser,
    updateUser,
    changePassword,
    getAddresses,
    addAddress,
    updateAddress,
    deleteAddress,
    setDefaultAddress,
    getPaymentMethods,
    addPaymentMethod,
    updatePaymentMethod,
    deletePaymentMethod,
    setDefaultPaymentMethod
};
